export const data = [
  {
    image: 'InstaKozi',
    link: 'https://www.instagram.com/p/BkKqSPwBB3r/',
  },
  {
    image: 'InstaDonuts',
    link: 'https://www.instagram.com/p/BmLbd2dFEMW/',
  },
  {
    image: 'InstaTesters',
    link: 'https://www.instagram.com/p/BoCKr2ihRaw/',
  },
  {
    image: 'InstaWebsummit',
    link: 'https://www.instagram.com/p/Bp2fGdKBlX1/',
  },
  {
    image: 'InstaSilence',
    link: 'https://www.instagram.com/p/BqXZXIUhYLc/',
  },
  {
    image: 'InstaChaos',
    link: 'https://www.instagram.com/p/BrM7royBX96/',
  },
];
